import React from 'react';
import { LibkeyLibrarySection } from './LibkeyLibrarySection/LibkeyLibrarySection';
import { LibkeySelection } from 'query/study/LibKey/Libraries';
import { PageContainer, PrimaryNavigationLayout } from 'components/shared';
import type { PrimaryNavigationLayoutProps } from 'components/shared/PrimaryNavigation/PrimaryNavigationLayout';
import { Stack } from 'components/layout';
import { Heading } from 'components/core';

export type LibKeyProps = PrimaryNavigationLayoutProps & {
  libkey?: LibkeySelection | null;
};

const LibKey = ({
  reviewer,
  header,
  subHeader,
  libkey = null,
}: LibKeyProps) => {
  return (
    <>
      <PrimaryNavigationLayout
        logoPath="/reviews"
        reviewer={reviewer}
        header={header}
        subHeader={subHeader}
      />
      <PageContainer isMain={true}>
        <Stack spacing={4}>
          <Heading type="h3">Integrations</Heading>
          <LibkeyLibrarySection initialSelection={libkey} />
        </Stack>
      </PageContainer>
    </>
  );
};

export { LibKey };
